import type { SnackbarItem, SnackbarItem as SnackbarItemType, State } from 'reactApp/modules/snackbar/snackbar.types';

const getSnackbarStore = (state: any): State => state.snackbar;

export const getSnackbarList = (state: any): SnackbarItem[] => Object.values(getSnackbarStore(state).list);
export const getBottomMargin = (state: any): number => getSnackbarStore(state).bottomMargin ?? 0;
export const getNoClosableSnackbars = (state: any): SnackbarItem[] =>
    getSnackbarList(state).filter((item: SnackbarItemType) => !item.closable);
